import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { UserService } from 'src/app/shared/services/user.service';
import { HomeComponent } from '../home/home.component';
import { VendorRegistrationComponent } from 'src/app/modules/authentication/components/vendor-registration/vendor-registration.component';
import { IconType } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SidebarService } from 'src/app/shared/services/sidebar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {
  isSidebarExpanded: boolean = true; // Default to expanded
  isMobileSidebarOpen: boolean = false;
  private sidebarSubscription?: Subscription;
  dragAndDropArea: HTMLElement | null;
   documentUploadInput: HTMLInputElement;


   constructor(   
    private _router: Router,
    private dialogService:DialogService,
    public userService: UserService,
    public sidebarService: SidebarService
  ) {

   }

  sidebarItems = [
    {
      label: 'Dashboard',
      icon: 'dashbored',
      route: '/home'
    },
    {
      label: 'Bank Account',
      icon: 'BankAccounts',
      route: '/BankAccount'
    },
    {
      label: 'Tenders',
      icon: 'Tenders',
      route: '/tender'
    },
    {
      label: 'Bids',
      icon: 'Bids',
      route: '/bid'
    },
    // {
    //   label: 'Messages',
    //   icon: 'Messages',
    //   route: '/Messages'
    // },
    {
      label: 'Financials',
      icon: 'finanace',
      route: '/financials'
    },
    {
      label: 'logout',
      icon: 'logout',
      route: '/logout'
    },

  ];

  ngOnInit(): void {
    // Subscribe to sidebar state changes
    this.sidebarSubscription = this.sidebarService.isMobileSidebarOpen$.subscribe(
      isOpen => {
        this.isMobileSidebarOpen = isOpen;
        // Prevent body scroll when sidebar is open on mobile
        if (window.innerWidth < 992) {
          if (isOpen) {
            document.body.classList.add('sidebar-open');
            // Ensure sidebar is expanded when opened on mobile
            this.isSidebarExpanded = true;
          } else {
            document.body.classList.remove('sidebar-open');
          }
        }
      }
    );

    const vendorId = this.userService.user?.EmailAddress; // Fetch vendorId from UserService
    if(vendorId == "sahani.amit@gmail.com" || vendorId == "a.sahani@qnbn.qa" ||  vendorId == "mali@newtecx.com")
    {
      this.sidebarItems.push({
        label: 'Email',
        icon: 'email',
        route: '/email'
      },
      {
        label: 'Manage Vendors',
        icon: 'users',
        route: '/manage-vendors'
      });
    }

  

    this.dragAndDropArea = document.getElementById('drag-and-drop-area');
    this.documentUploadInput = document.getElementById('document-upload-input') as HTMLInputElement;

    this.dragAndDropArea?.addEventListener('click', () => this.documentUploadInput.click());

    this.dragAndDropArea?.addEventListener('dragover', (event) => {
      event.preventDefault();
      this.dragAndDropArea?.classList.add('dragover');
    });

    this.dragAndDropArea?.addEventListener('dragleave', () => {
      this.dragAndDropArea?.classList.remove('dragover');
    });

    this.dragAndDropArea?.addEventListener('drop', (event) => {
      event.preventDefault();
      this.dragAndDropArea?.classList.remove('dragover');
      const files = event?.dataTransfer!.files;
      this.documentUploadInput.files = files;
      // Handle the files
    });

    this.documentUploadInput.addEventListener('change', (event) => {
      const files = (event.target as HTMLInputElement).files;
      // Handle the files
    });
  }

  toggleSidebar(): void {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }

  isActiveRoute(route: string | undefined): boolean {
    return route ? this._router.url === route : false;
}



  handleButtonClick(event: Event,btn : string): void {
    if (!this.isSidebarExpanded) {
      event.preventDefault();
    }
    if (btn == 'logout') {
      this.dialogService.showDialog(
        'Logout',  // Title
        'Are you sure you want to logout?',  // Content
        IconType.Warning,  // Icon type
        true,  // Show confirm button
        this.LogOut.bind(this)  // Pass the delete function to be executed
      );

    }
  }

  LogOut() {
    this.userService.logout();
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
  }

  handleSendMessage(messageContent: string) {
    console.log('Message Sent:', messageContent);
    // Add logic to send the message to the backend or process the message.
  }

  ngOnDestroy(): void {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
  }

  // Close sidebar when clicking on a link (mobile only)
  onSidebarLinkClick(): void {
    if (window.innerWidth < 992) {
      this.sidebarService.closeMobileSidebar();
    }
  }

  // Close sidebar when clicking outside (mobile only)
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (window.innerWidth < 992 && this.isMobileSidebarOpen) {
      const sidebar = document.getElementById('sidebar');
      const hamburgerBtn = document.querySelector('.hamburger-btn');
      
      if (sidebar && hamburgerBtn) {
        const isClickInsideSidebar = sidebar.contains(event.target as Node);
        const isClickOnHamburger = hamburgerBtn.contains(event.target as Node);
        
        if (!isClickInsideSidebar && !isClickOnHamburger) {
          this.sidebarService.closeMobileSidebar();
        }
      }
    }
  }

  // Close sidebar when window is resized to desktop size
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event): void {
    if (window.innerWidth >= 992 && this.isMobileSidebarOpen) {
      this.sidebarService.closeMobileSidebar();
      document.body.classList.remove('sidebar-open');
    }
  }
  
}
